import { ILevel3, ISeason, OmekaMedia, Season } from './generalTypes';
import { FormikErrors } from 'formik';
import axios from 'axios';
import { Box } from '@mui/material';
import { defaultRenderArray } from '../components/Details/Details';
import { UserRole } from '../components/dictionaries/Role';
import { administrator_options, ekome_editor_options, ekome_publisher_options, film_office_editor_options, film_office_publisher_options } from './static/users/selectOptions';
import { IMediaSliders, MediaSlides } from '../components/Carousel/types';
import { IMediaAttachments } from '../pages/ΟΑ/Tekmirio/types';
import { greekToEnglishLetters } from './mappings/generalMapping';

/* 
merge array of object :
    input -> [{a: {...}}, {b: {...}}, {c: {...}}] 
into JSON Object :
    returns -> {a: {...}, b: {...}, c: {...}}
**/
export const mergeArrayOfObjectIntoJSONObject = (JSONobject: any): any => {
  return JSONobject.reduce(function (result: any, current: any) {
    return Object.assign(result, current);
  }, {});
};

export const mergeObjectWithSameKeys = (a: any, b: any) => {
  const keys = Object.keys(a);
  const result: any = {};
  keys.forEach((key) => {
    result[key] = {
      ...a[key],
      ...b[key],
    };
  });
  return result;
};

export const createFilterModel = (filters: any) => {
  const _filters = Object.keys(filters).map((filter) => {
    if (Array.isArray(filters[filter])) {
      const ArrayObjectValues = filters[filter].map((filt: any) => {
        return filt.value;
      });
      return {
        [filter]: ArrayObjectValues
      };
    }
    return {
      [filter]: filters[filter],
    };
  });
  return Object.assign({}, ..._filters);
};

// Creates a JSON object according to current year with the start and end dates for each Season
export const seasonsBuilder = (estimatedYear: number) => {
  const seasons: Season[] = [
    Season.Winter,
    Season.Spring,
    Season.Summer,
    Season.Fall,
  ];
  const seasonObject: any = seasons.map((seasonString: Season) => {
    switch (seasonString) {
    case Season.Winter:
      // 2020-12-01/2021-02-28
      return {
        winter: {
          dateStart: `${estimatedYear}-12-01`,
          dateEnd: `${estimatedYear + 1}-02-28`,
        },
      };
    case Season.Spring:
      // 2021-03-01/2021-05-31
      return {
        spring: {
          dateStart: `${estimatedYear + 1}-03-01`,
          dateEnd: `${estimatedYear + 1}-05-31`,
        },
      };
    case Season.Summer:
      // 2021-06-01/2021-08-31
      return {
        summer: {
          dateStart: `${estimatedYear + 1}-06-01`,
          dateEnd: `${estimatedYear + 1}-08-31`,
        },
      };
    case Season.Fall:
      // 2021-09-01/2021-11-30
      return {
        fall: {
          dateStart: `${estimatedYear + 1}-09-01`,
          dateEnd: `${estimatedYear + 1}-11-30`,
        },
      };
    default:
      return;
    }
  });

  const arrayOfSeason: ISeason = mergeArrayOfObjectIntoJSONObject(seasonObject);
  return [arrayOfSeason];
};

export const parseOmekaTags = (omekaTags: string) => {
  if (!omekaTags) return;
  return omekaTags.split(',');
};

export const isOmekaMediaType = (type: OmekaMedia, omekaResp: any) =>
  omekaResp['o:media_type']?.includes(type);

export const convertTagsToArray = (tags: string): string[] => {
  if (tags !== '-' && !Array.isArray(tags)) {
    return tags?.split(',');
  } else {
    return [];
  }
};

export const downloadFileFullPath = async (fullPath: string) => {
  try {
    const fileResponse = await axios({
      url: fullPath,
      method: 'GET',
      responseType: 'blob',
    });
    const url = window.URL.createObjectURL(new Blob([fileResponse.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${fullPath?.split('/')?.at(-1)}`);
    document.body.appendChild(link);
    link.click();
  } catch (error) {
    console.error(error);
  }
};

/** Download a file from blob object  
 * @param file 
*/
// TODO: save blob on click
export function saveFile(file: File) {
  // const json = JSON.stringify(file);
  const blob = new Blob([file], { type: file.type });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  document.body.appendChild(a);
  a.href = url;
  a.download = file.name;
  a.click();
  window.URL.revokeObjectURL(url);
}

export function removeNthEl(arr: any[], i: number) {
  return [
    ...arr.slice(0, i),
    ...arr.slice(i + 1)
  ];
}
export const eliminateOjectNotTruthyValues = (object: any) => {
  const _arr = Object.keys(object)
    .map((key) => {
      if (Array.isArray(object[key])) {
        //handle Multiselect values, returns all the { key: '', value: '' } object
        if (typeof object[key][0] === 'object' && object[key][0] !== null) {
          return {
            [key]: object[key]
          };
        }
        if (object[key].length > 0) {
          return {
            [key]: object[key].reduce((x: any, y: any) => `${x},${y}`),
          };
        }
      } else if (
        object[key] !== null &&
        object[key] !== undefined &&
        object[key] !== '' &&
        object[key] !== 'all'
      ) {
        return {
          [key]: object[key],
        };
      }
    })
    .filter((a) => a); // filter: eliminate not truthy values
  return Object.assign({}, ..._arr);
};

export const maxValidationString = (maxChar: number, keywordHelperText: string | undefined = '') => {
  return (`Παρακαλώ ο αριθμός των χαρακτήρων πρέπει να είναι μέχρι ${maxChar} ${keywordHelperText}\n`);
};

export const minValidationString = (minChar: number) => {
  return (`Παρακαλώ ο αριθμός των χαρακτήρων πρέπει να είναι τουλάχιστων ${minChar}`);
};
export const maxValidationNumber = (maxChar: number) => {
  return (`Ο αριθμός δεν μπορεί να είναι μεγαλύτερος από ${maxChar}`);
};
export const minValidationNumber = (minChar: number) => {
  return (`Ο αριθμός δεν μπορεί να είναι μικρότερος από ${minChar}`);
};
export const postalCodeErrorMessage = () => {
  return ('Παρακαλώ συμπληρώστε αριθμό με ακριβώς 5 ψηφία');
};
export const requiredField = 'Υποχρεωτικό πεδίο, παρακαλώ συμπληρώστε.';

export const findGeolocationFromAddress = async (address: string | null) => {
  try {
    const geocoder = new google.maps.Geocoder();
    const response = await geocoder.geocode({ region: 'GR', address });
    const { lat, lng } = response.results[0].geometry.location;

    return { lat: lat(), lng: lng() };
  } catch (error) {
    return { lat: 0, lng: 0 };
  }
};

export const validateFileSize = (value: File[], filesize = 4): boolean => {  
  const _values = value?.filter(val => typeof val !== 'string');  
  
  if (_values && _values.length > 0) {
    return _values?.every(file => file?.size <= filesize * 1000000);
    
  } else return true;
};

export const validateSingleFileSize = (value: File[], filesize = 4): boolean => { 
  if (value && typeof value[0] === 'object') {
    return value[0].size <= filesize * 1000000;
  } else {
    return true;
  }
};

export const isSubmitEnabled = (  
  errors: FormikErrors<any>, touched: boolean, checkCertainErrors?: string[]
) => {  
  let disabledButton;  
  const errors_bool = !!Object.keys(errors).length;
  if (!touched) {
    disabledButton = true;
  } else if (checkCertainErrors) {
    disabledButton =
      checkCertainErrors?.map((check: string) => errors[check]).filter(Boolean).length > 0;
  } else if (errors_bool) {
    disabledButton = true;
  }
  return disabledButton;
};

export const createSearchParamsFormat = (values: any) => {
  let _values = values;
  for (const [key, value] of Object.entries(values)) {
    let filters;
    if (Array.isArray(value) && typeof value[0] === 'object' && value[0] !== null) {
      filters = value.map((val) => val.value);
      _values = { ..._values, [key]: filters };
    }
  }
  return eliminateOjectNotTruthyValues(_values);
};

export const checkValueInclusionInArray = (array: any, value: number | string): boolean => {
  let isIncluded;
  if (typeof array[0] === 'object' && array[0] !== null) {
    isIncluded = array.some((x: any) => x.value == value);
  } else isIncluded = array.includes(value);
  return isIncluded;
};

/* 
if array in format 
[
  {
    "Φύση": [
      "Βουνό",
      "Υδάτινο Στοιχείο"
    ]
  },
  {
    "Κτίριο": []
  }
] will be rendered as: 
Φυση: Βουνο, Υδατινο Στοιχειο,
Κτιριο

else defaultRenderArray --> [tag1, tag2] => tag1,tag2
**/
export const arrayDetailsFormat = (array: any) => {
  if (typeof array[0] === 'object' && array[0] !== null) {
    const x = array.map((arr: any, ind: number) => {
      const values: any[] = Object.values(arr);
      let key = `${Object.keys(arr)[0]}`;
      if (Array.isArray(values)) {
        key = values[0].length === 0
          ? `${Object.keys(arr)[0]}`
          : `${Object.keys(arr)[0]}:`;
      }
      return <Box key={ind}>{key} {Object.values(arr).join(',')}</Box>;
    });
    return x;
  } else {
    return defaultRenderArray(array);
  }
};

export const createOrderModel = (sortModel: any) => {
  return sortModel.length > 0
    ? { order: [sortModel[0].field, sortModel[0].sort] }
    : [];
};

export const createPaginationModel = (page: number, pageSize: number | undefined) => {
  return {
    page: page,
    page_length: pageSize,
  };
};
const getIdFromResourceUri = (resourceUri: string) => {
  const uriParts = resourceUri.split('/');
  return uriParts[uriParts.length - 1];
};


export const getLocation3CategoriesTreeWithCorrespondingChildren = (level3data: any) => {
  const level3properties: {
    id: number;
    title: string;
    level1Id: string;
    level1Title: string;
    parent: string;
    children: {
      id: string;
      title: string;
    }
  }[] = [];
  level3data.forEach((item: any) => {
    level3properties.push({
      id: item['o:id'],
      title: item['o:title'],
      level1Id: getIdFromResourceUri(item?.['dcterms:relation'][0]['@id']),
      level1Title: item['dcterms:relation'][0]['display_title'],
      parent: item['dcterms:relation'][0]['value_resource_id'],
      children: item['@reverse']['dcterms:relation'].map((child: any) => {
        return {
          id: getIdFromResourceUri(child['@id']),
          title: child['o:title'],
        };
      }),

    });
  });
  return level3properties;
};

// return options based on role
export const getOptions = (Role?: string) => {
  switch (Role) {
  case UserRole.Administrator:
    return administrator_options;
  case UserRole.Ekome_Editor:
    return ekome_editor_options;
  case UserRole.Ekome_Publisher:
    return ekome_publisher_options;
  case UserRole.Film_Office_Editor:
    return film_office_editor_options;
  case UserRole.Film_Office_Publisher:
    return film_office_publisher_options;
  default:
    return [];
  }
};

export const showOnlySelectedOptions = (selected: any, options: ILevel3[]) => {
  const selectedOptions = selected.map((selectedItem: any) => {
    return options?.filter((option: ILevel3) => option.level1Id == selectedItem.value);
  });

  return selectedOptions?.flat() || [];
};

export const checkMediaType = (url: string) => {
  const urlArray = url?.split('.') || [];
  if (urlArray[urlArray.length - 1] === 'mp4') {
    return 'video';
  }
  else if (urlArray[urlArray.length - 1] === 'gif') {
    return 'gif';
  }
  else {
    return 'image';
  }
};

export const formatMediaData = (data: any): {
   images: IMediaSliders[]; videos: IMediaSliders[]; thumbnail: MediaSlides | undefined; 
  } => {
  const images = data?.media.map((x: any) => {
    if (checkMediaType(x) === 'image') {
      return {
        url: x,
        thumbnail: x,
      };
    }
  }).filter((a: any) => a);

  const videos = data?.media.map((x: any) => {
    if (checkMediaType(x) === 'video') {
      return {
        url: x,
        thumbnail: 'https://min01rg40sa01.blob.core.windows.net/defaults/default_video_thumbnail.png',
      };
    }
  }).filter((a: any) => a);
    
  const thumbnail = data?.thumbnail
    ? { url: data?.thumbnail, thumbnail: data?.thumbnail }
    : undefined;

  return { images, videos, thumbnail };
};

export const readableBytes = (bytes: number) => {
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const x = (bytes / Math.pow(1024, i)).toFixed(2);
  return x;
};

export const formatMediaDataOmeka = (data: any): {
  images: IMediaSliders[]; thumbnail: MediaSlides | undefined;
  videos: IMediaSliders[]; attachments: IMediaAttachments[];
} => {
  let thumbnail;
  if (data?.item?.['thumbnail_display_urls']?.['large']) {
    thumbnail = {
      url: data?.item?.['thumbnail_display_urls']?.['large'],
      thumbnail: data?.item?.['thumbnail_display_urls']?.['square'],
    };
  }

  const images = data?.media.map((x: any) => {
    if (isOmekaMediaType(OmekaMedia.Image, x)) {
      return {
        url: x['thumbnail_display_urls']?.['large'],
        thumbnail: x['thumbnail_display_urls']?.['square'],
        title: x['o:source']
      };
    }
  }).filter((a: any) => a);

  const videos = data?.media.map((x: any) => {
    if (isOmekaMediaType(OmekaMedia.Video, x)) {
      return {
        url: x['o:original_url'],
        thumbnail: `${process.env.REACT_APP_OMEKA_URL}${x['thumbnail_display_urls']?.['medium']}`,
        title: x['o:source']
      };
    }
  }).filter((a: any) => a);

  const attachments = data?.media.map((x: any) => {
    if (isOmekaMediaType(OmekaMedia.Attachments, x)) {
      return {
        url: x['o:original_url'],
        fileName: x['o:source'] || x['o:title'],
        size: `${readableBytes(x['o:size'])} MB`,
      };
    }
  }).filter((a: any) => a);
  return { images, videos, thumbnail, attachments };
};

export const matchRefsWithData = (
  data: any,
  detailRefs: {
    refValue: string, title: string
  }[]
) => {
  return detailRefs.map((ref) => {
    return {
      name: ref.title,
      value: data?.[ref.refValue] || data?.[ref.refValue] === 0
        ? String(data?.[ref.refValue])
        : '-'
    };
  });
};

export const transformBlobToFile = (blobArray: any) => {
  return blobArray?.map((blob: any) => {
    const file = new File([blob], blob?.name.split('/').pop(), {
      type: blob?.properties.contentType,
    });
    return file;
  });
};

export const formatAzureFiles = (attached_files: any): IMediaAttachments[] => {
  if (Array.isArray(attached_files)) {
    return attached_files.map((file: string) => {
      return {
        url: file,
        fileName: file.split('/').pop() || ''
      };
    });
  } else {
    return [{
      url: attached_files,
      fileName: attached_files.split('/').pop()
    }];
  }
};

export const downloadBase64PDF = (pdfFile: string, fileName: string) => {
  const linkSource = `data:application/pdf;base64,${pdfFile}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
};

export const sortCustomOrderObject = (orderArray: string[], data: any) => {

  if (!data) return;
  const sortedData = Object.keys(data).sort((a, b) =>
    orderArray.indexOf(a) - orderArray.indexOf(b))
    .reduce((obj: any, key: string) => {
      obj[key] = data[key];
      return obj;
    }, {});
  return sortedData;
};


export const capitalizeFirstLetter =
  (string: string) => string.charAt(0).toUpperCase() + string.slice(1);

export const splitStringByDashAndCapitalizeFirstLetterOfEachWord = (string: string): string => {
  const splitString = string.split('-');
  const urlString = splitString.map((word) => capitalizeFirstLetter(word)).join(' ');
  return urlString;
};

export const buildRedirectTranslatedUrl = () => {
  const url = process.env.REACT_APP_APP_URL_EDIT;
  const language = document?.getElementsByTagName('html')?.[0]?.getAttribute('lang') || '';
  // replace all before hashtag character
  const newUrl = url?.replaceAll(':lang/', language === 'en-US'
    ? ''
    : 'el/');
  return newUrl;
};

//Comparer Function when Array is an Array of JSON Objects
export const GetSortOrder = (prop: string) => {    
  return (a: any, b: any) => {    
    if (a[prop] > b[prop]) {    
      return 1;    
    } else if (a[prop] < b[prop]) {    
      return -1;    
    }    
    return 0;    
  };    
}; 

export const transformGreekToEnglish = (text: string) => {
  let result = '';
  for (let i = 0; i < text?.length; i++) {    
    const letter: string = text[i];
    if (greekToEnglishLetters[letter]) {
      result += greekToEnglishLetters[letter];
    } else {
      result += letter;
    }
  }
  if (result.includes('Aerolimenas')) {
    result = result.replace(/Aerolimenas/g, 'Airport');
  }
  if (result.includes('Limani')) {
    result = result.replace(/Limani/g, 'Port');
  } 

  return result;
};

export const getItemId = (url: string): any => {
  const parts = url.split('/');
  return parts.length > 0
    ? parts[parts.length - 1]
    : null;
};

export const downloadExcel = (response: any, name_of_excel: string) => {
  const blob = new Blob([response.data], { type: response.headers['content-type'] });
  const csvURL = window.URL.createObjectURL(blob);
  const tempLink = document.createElement('a');
  tempLink.href = csvURL;
  tempLink.setAttribute('download', `${name_of_excel}.xlsx`);
  tempLink.click();
};

export const validateLocationCoordinates = (
  formRef: React.RefObject<any>, latitude: string | null, longitude: string | null
) => {
  formRef?.current?.registerField('location', {
    validate: () => latitude == null && longitude == null
      ? 'Δεν βρέθηκε τοποθεσία'
      : ''
  });
  if (latitude !== null && longitude !== null) {
    formRef?.current?.setFieldError('location', undefined);
  }
  formRef?.current?.setFieldValue('location', { lat: latitude, lng: longitude });
};

/**
 * @param media_urls all the media urls that are contained in the ../original/.. azure container
 * @returns all the urls from the compressed container
 */
export function formatMediaUrlsToCompressed(media_urls: string[]) {
  return media_urls.map((url: string) => {
    const image_name = url?.split('/')?.at(-1)?.split('.').at(0);
    return `${url.replace('original', 'compressed').split('/').slice(0, -1).join('/')}/compressed_${image_name}.webp`;
  });
}